import CommonEntry from 'components_v2/_entryPoints/grouped/CommonEntry'
import React from 'react'

const Entry = (props) => <CommonEntry {...props} />

export default Entry
